'use client';

import { useEffect, useState, ReactNode } from 'react';

export default function ClientOnly({
    children,
    fallback = <span className="opacity-0">...</span>
}: {
    children: ReactNode;
    fallback?: ReactNode;
}) {
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        setMounted(true);
    }, []);

    if (!mounted) {
        return <>{fallback}</>;
    }

    return <>{children}</>;
}